let comm = {};

comm.getLocationDomain = function(url){ //获取域名
  if(!url){
    return location.protocol + '//' + location.host;
  } else {
    let arr = url.split('://');
    let protocol = arr[0];
    let nextUrl = arr[1];
    let arr2 = nextUrl.split('/');
    let host = arr2[0];
    let result = protocol + '://' + host;
    return result;
  }
};

comm.getAppName = function () {
  let appName = 'KIAF';
  let arr = location.pathname.split('/');
  let contextPath = arr.find((value) => value != '') || '';
  if(contextPath && contextPath != 'static' && contextPath.indexOf('.') < 0) {
    appName = contextPath;
  }
  return appName;
};

comm.getLayout = function () {
  let result = sessionStorage.getItem('KIAF_LAYOUT') || 'H';
  return result;
};

comm.setLayout = function (value) {
  sessionStorage.setItem('KIAF_LAYOUT', value);
};

comm.getEnv = function () {
  let env = this.env || 'production';
  // if (process.env.NODE_ENV) {
  //   env = process.env.NODE_ENV;
  // }
  return env;
};

comm.setEnv = function (value) {
  this.env = value;
};

comm.getContentPath = function () {
  let result = '';
  if (this.getEnv() !== 'development' && this.contentPath) {
    result = this.contentPath;
  }
  return result;
};

comm.getOrgContentPath = function () {
  return this.contentPath || '';
};

comm.setContentPath = function (value) {
  this.contentPath = value;
};

comm.isEmpty = function (value) {
  if (value === undefined || value === null || value === 'null' || value === '' || value.length <= 0) {
    return true;
  } else {
    return false;
  }
};

comm.isNull = function (value) {
  if (value == undefined || value == null) {
    return true;
  } else {
    return false;
  }
};

comm.getUrlParam = function(name) {
  let url = document.location.toString();
  let arrObj = url.split('?');

  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split('&');
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=');
      if (arr != null && arr[0] == name) {
        return arr[1];
      }
    }
    return '';
  } else {
    return '';
  }
};

comm.clone = function (value) {
  try {
    return JSON.parse(JSON.stringify(value));
  }catch (e) {

  }
};

comm.isChinese = function (char) {
  let re = /[\u4e00-\u9fa5]/g;
  if (re.test(char)) return true;
  return false;
};

comm.calcLength = function (str) {
  let len = 0;
  if(!this.isEmpty(str)){
    let arr = str.split('');
    arr.forEach(char => {
      if(this.isChinese(char)){
        len += 2;
      } else {
        len += 1;
      }
    });
  }
  return len;
};
comm.isIE = function() { //ie?
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
};

comm.formatDateTime = function(value, strFormat){
  let dateTime = new Date(value);
  let yyyy = dateTime.getFullYear();
  let mm = dateTime.getMonth() + 1;
  let dd = dateTime.getDate();
  let hh = dateTime.getHours();
  let mi = dateTime.getMinutes();
  let ss = dateTime.getSeconds();
  mm = mm < 10 ? '0' + mm : mm;
  dd = dd < 10 ? '0' + dd : dd;
  hh = hh < 10 ? '0' + hh : hh;
  mi = mi < 10 ? '0' + mi : mi;
  ss = ss < 10 ? '0' + ss : ss;
  if(!strFormat){
    strFormat = 'YYYY-MM-DD HH:MI:SS';
  }
  return strFormat.toLowerCase().replace('yyyy', yyyy).replace('mm', mm).replace('dd', dd).replace('hh', hh).replace('mi', mi).replace('ss', ss);
};

comm.clearAppStorage = function(whiteList) {
  for(let key in localStorage){
    if(key.indexOf(this.getAppName()) === 0 && whiteList.indexOf(key) < 0 && key.indexOf('_WHITELIST') < 0){
      localStorage.removeItem(key);
    }
  }
};

comm.addClass = function (elem, className) {
  if(elem){
    this.removeClass(elem, className);
    if(elem.className){
      className = elem.className + ' ' + className;
    }
    elem.className = className;
  }
};

comm.removeClass = function (elem, className) {
  if(elem){
    let preClassName = elem.className;
    let newClassName = preClassName;
    if(preClassName === className){
      newClassName = '';
    } else { //需要考虑模糊匹配的其他class干扰
      let indexOf = preClassName.lastIndexOf(className);
      if(indexOf >= 0){
        if(indexOf + className.length === preClassName.length){ //出现在最后
          newClassName = preClassName.substring(0, indexOf);
        } else {
          newClassName = preClassName.replace(' ' + className + ' ', ' '); //替换中间部分;
          if(newClassName === preClassName){ //替换失败
            newClassName = preClassName.replace(className + ' ', ''); //替换头部部分;
          }
        }
      }
    }
    elem.className = newClassName;
  }
};

comm.getHost = function () {
  let arr = location.pathname.split('/');
  let arr2 = [];
  for(let i = 0; i < arr.length; i++){
    let path = arr[i];
    if(path == 'static' || path == 'main' || path == 'submodule' || path == 'kiaf_hash'){
      break;
    } else if(!this.isEmpty(path)){
      arr2.push(path);
    }
  }
  let contextPath = '';
  arr2.forEach( path => {
    contextPath += ('/' + path);
  });
  let protocol = window.location.protocol;
  let baseUrl = protocol + '//' + location.host + contextPath;
  return baseUrl;
};

comm.getChannelCode = function(url){
  let hostUrl = url || this.getHost();
  let index = hostUrl.indexOf('://');
  if(index > 0){
    hostUrl = hostUrl.substring(index + '://'.length);
  }
  // let suffix = hostUrl.substring(location.protocol.length, hostUrl.length);
  let result = hostUrl.replace(/\//g, '').replace(/\./g, '').replace(/:/g, '');
  return result;
};

comm.getFullUrl = function (url) {
  let fullUrl = '';
  if(url.indexOf('http') == 0){
    fullUrl = url;
  } else{
    if (url && url.indexOf('#') < 0) {
      url = '/#' + url;
    }
    fullUrl = this.getHost() + url;
  }
  return fullUrl;
};

comm.getPath = function () {
  let hash = location.hash;
  let arr = hash.split('?');
  let paths = [];
  if(arr && arr.length >= 1){
    paths = arr[0].split('#');
  }
  let result = '';
  paths.forEach(path => {
    result += path;
  });
  return result;
};

comm.getMatchPath = function (fullPath , config= {replaceTime: true}) {
  if(fullPath){
    let windowId = window.name;
    fullPath = fullPath.replace(new RegExp(/[?,&]chromeExtWin=Y/g), '');//忽略chromeExtWin
    fullPath = fullPath.replace(new RegExp(`[?,&]windowId=${windowId}`, 'g'), '');//忽略chromeExtWin
    fullPath = fullPath.replace(new RegExp(/[?,&]hide_menu=single/g), '');//忽略hide_menu
    fullPath = fullPath.replace(new RegExp(/[?,&]subwindow=Y/g), '');// ?time=xxx || &time=xxx
    if(config.replaceTime){
      fullPath = fullPath.replace(new RegExp(/[?,&]time=[0-9]{13}/g), '##');// ?time=xxx || &time=xxx
    }
    let arr = fullPath.split('##');
    return arr[0];
  } else {
    return '';
  }
};

comm.isHighPerformanceBrowser = function () {
  let jsHeapSizeLimit = 0;
  if (window.performance && window.performance.memory) {
    jsHeapSizeLimit = window.performance.memory.jsHeapSizeLimit;
  }
  return jsHeapSizeLimit > 3 * 1024 * 1024 * 1024;
};

comm.getChromeVersion = function () {
  let version = 0;
  try {
    let arr = navigator.userAgent.split(' ');
    var result = '';
    for (let i = 0; i < arr.length; i++) {
      if (/chrome/i.test(arr[i])) {
        result = arr[i];
      }
    }
    if (result) {
      version = Number(result.split('/')[1].split('.')[0]);
    }
  }catch (e) {
    version = 0;
  }
  return version;
}

comm.setLocalStorage = function (key, value) {
  if(typeof value == 'object'){
    value = JSON.stringify(value);
  }
  if(key.indexOf(this.getAppName()) != 0){
    key = this.getAppName() + '_' + key;
  }
  localStorage.setItem(key, value);
}
comm.getLocalStorage = function (key) {
  if(key.indexOf(this.getAppName()) != 0){
    key = this.getAppName() + '_' + key;
  }
  localStorage.getItem(key);
}
comm.setSessionStorage = function (key, value) {
  if(typeof value == 'object'){
    value = JSON.stringify(value);
  }
  if(key.indexOf(this.getAppName()) != 0){
    key = this.getAppName() + '_' + key;
  }
  sessionStorage.setItem(key, value);
}
comm.getSessionStorage = function (key) {
  if(key.indexOf(this.getAppName()) != 0){
    key = this.getAppName() + '_' + key;
  }
  sessionStorage.getItem(key);
}

comm.importScss = function (type, _theme) {
  if(process.env.NODE_ENV == 'development'){
    require('static/theme/' + type + '/' + _theme + 'index.scss');
  }
}

export default comm;
